import image1 from "../images/memberships/Enmascarar grupo 7.png";
import first from "../images/memberships/first.png";


const memberships = [
    {
        id: 0,
        image: image1,
        icon: first,
        title: "Inversión",
        price: "67",
        price_before: "189",
        items: [
            {
                item: "Acceso a clases en vivo y grabaciones",
                more: null,
            },
            {
                item: "Feedback en vivo y grabaciones",
                more: null,
            },
            {
                item: "Acceso por un año al contenido.",
                more: null,
            },
            { item: "Acceso a Discord Privado", more: null },
        ],
        urls: [
            {
                name: "Pagar con PayPal",
                url: "https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=C62KAFQEK7F6S",
            },
            {
                name: "Pagar con Tarjeta",
                url: "https://payco.link/1490903",
            },
        ],
        endDiscount: 'Mon, 10 Oct 2022 23:59:59 GMT-5',
    },
];

export default memberships;
